/* eslint-disable no-unused-vars */
import TextField from '@material-ui/core/TextField';
import createComponent from '@components/redux-form-material-ui/createComponent';
import { mapError } from '@components/redux-form-material-ui/utils';

export default createComponent(TextField, ({ defaultValue, ...props }) => ({
    ...mapError(props),
}));
